import React from 'react';

import { useFormContext } from '@lumapps/lumx-forms';
import { useSelector } from '@lumapps/redux/react';

import { getOwnerResourceInfo } from '../../ducks/selectors';
import { OwnerResourceInfo } from '../../types';

export const useOwnerResourceInfo = (shouldReturnFixedOwnerInfo?: boolean) => {
    const fixedOwnerResourceInfo = useSelector(getOwnerResourceInfo);

    // The form context will be defined only in the designer.
    const formContext = useFormContext();
    const [id, type, title, thumbnail, mediaThumbnail, thumbnailAltText, externalKey, instance] =
        formContext?.watch?.([
            'id',
            'type',
            'title',
            'thumbnail',
            'mediaThumbnail',
            'thumbnailAltText',
            'externalKey',
            'instance',
        ]) || [];

    const liveOwnerResourceInfo = React.useMemo(() => {
        if (!shouldReturnFixedOwnerInfo && formContext) {
            return {
                ownerResourceId: id,
                ownerResourceType: type === 'community' ? 'community' : 'content',
                properties: {
                    title,
                    thumbnail,
                    mediaThumbnail,
                    externalKey,
                    instance,
                    thumbnailAltText,
                },
            } as OwnerResourceInfo;
        }
        return undefined;
    }, [
        externalKey,
        formContext,
        id,
        instance,
        mediaThumbnail,
        shouldReturnFixedOwnerInfo,
        thumbnail,
        thumbnailAltText,
        title,
        type,
    ]);

    return shouldReturnFixedOwnerInfo ? fixedOwnerResourceInfo : liveOwnerResourceInfo || fixedOwnerResourceInfo;
};
